package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/moana". Pulls the REAL cached analysis from PROD. */
@Page("/isitsafe/moana")
@Composable
fun MoanaReviewPage() {
    PublicReviewPage(
        slug = "moana",
        blurb = "Thinking about watching Moana with your children? Fitrah Filter checks movies, shows, and games against Islamic values. Here's an honest look at the good, the concerns, and the evidence behind them.",
    )
}
